export default __webpack_public_path__ + "static/media/circle-check-solid.64c53284.svg";